// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2q5bq","title":"Header_title__3RgfR","left":"Header_left__1ZjxW","clinicName":"Header_clinicName__qKhG1"};